import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const History = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="History" {...props}>
    <path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C8.25423 23 4.93838 21.1253 3 18.2588V21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21V16C1 15.4477 1.44772 15 2 15H7C7.55228 15 8 15.4477 8 16C8 16.5523 7.55228 17 7 17H4.56543C6.12407 19.404 8.87062 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.64704 3 4.01349 6.09161 3.17969 10.1992C3.06967 10.7403 2.54211 11.0903 2.00098 10.9805C1.45975 10.8706 1.10986 10.342 1.21973 9.80078C2.23909 4.77954 6.67721 1 12 1Z" fill="#000" /><path d="M12 6C12.5523 6 13 6.44772 13 7V11.5L16.5996 14.2002C17.0414 14.5315 17.131 15.1578 16.7998 15.5996C16.4685 16.0414 15.8422 16.131 15.4004 15.7998L11.4004 12.7998C11.1486 12.611 11 12.3148 11 12V7C11 6.44772 11.4477 6 12 6Z" fill="#000" />
  </StyledIcon>
));

History.displayName = 'History';

export { History };
